module.exports = __webpack_public_path__ + "static/media/Concepcion.356a5052.png";